<p-toast></p-toast>
<div class="target-system-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <!-- <div class="flex justify-content-between flex-wrap card-container purple-container">
                <div class="flex align-items-center justify-content-center">
                    <h5 class="mt-0">{{'TARGET_SYSTEM'| translate}}</h5>
                </div>
                <div class="flex align-items-center justify-content-center my-2">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help m-3"></button>
                        <p-menu #menu [popup]="true"  [model]="appVerificationItems"></p-menu>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                      class="p-button-info ml-3"></button>
                </div>
            </div> -->
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                  <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_TARGET'| translate}}" (click)="addTarget()" class="p-button-success" ></button>
                  <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                </ng-template>
                <ng-template pTemplate="right">
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help m-3"></button>
                    <p-menu #menu [popup]="true"  [model]="appVerificationItems"></p-menu> -->
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                  class="p-button-info ml-3"></button>
                </ng-template>
        
              </p-toolbar>
            <p-table #targetTable [value]="targetTableData" [rows]="10" [paginator]="true"
                [globalFilterFields]="
                ['GeoId', 
                'CropId',
                'ProgId',
                'Area',
                'FarmersToBeBenefitted',
                'Amount',
                'StartDate',
                'EndDate']"
                responsiveLayout="scroll" [(selection)]="targetTableData" [rowHover]="true" dataKey="GeoId"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'TARGET_SYSTEM'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="targetTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="GeoId">{{'GeoId'| translate}}
                            <p-columnFilter type="text" field="GeoId" display="menu"></p-columnFilter>
                            <p-sortIcon field="GeoId"></p-sortIcon>
                        </th>

                        <th pSortableColumn="CropId">{{'CropId'| translate}}
                            <p-columnFilter type="text" field="CropId" display="menu"></p-columnFilter>
                            <p-sortIcon field="CropId"></p-sortIcon>
                        </th>

                        <th pSortableColumn="ProgId">{{'ProgId'| translate}}
                            <p-columnFilter type="text" field="ProgId" display="menu"></p-columnFilter>
                            <p-sortIcon field="ProgId"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Area">{{'Area'| translate}}
                            <p-columnFilter type="text" field="Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmersToBeBenefitted">{{'FarmersToBeBenefitted'| translate}}
                            <p-columnFilter type="text" field="FarmersToBeBenefitted" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmersToBeBenefitted"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Amount">{{'Area'| translate}}
                            <p-columnFilter type="text" field="Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="StartDate">{{'Area'| translate}}
                            <p-columnFilter type="text" field="StartDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="StartDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="EndDate">{{'EndDate'| translate}}
                            <p-columnFilter type="text" field="EndDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="EndDate"></p-sortIcon>
                        </th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{product.GeoId}}</td>
                        <td>{{product.CropId}}</td>
                        <td>{{product.ProgId}}</td>
                        <td>{{product.Area}}</td>
                        <td>{{product.FarmersToBeBenefitted}}</td>
                        <td>{{product.Amount}}</td>
                        <td>{{product.StartDate}}</td>
                        <td>{{product.EndDate}}</td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>
